{
  "invite": "Invite",
  "emptyTitle": "You are alone in this organization",
  "emptyHint": "Invite engineers and observers. The system generates the password — it is shown once and must be changed at first sign-in.",
  "loadFailed": "Could not load the users",
  "loadFailedHint": "{{reason}} You may not have the org:admin permission.",
  "passwordNotChanged": "password not changed",
  "neverLoggedIn": "never",
  "itIsYou": "this is you",
  "editAria": "Edit {{name}}",
  "editTitle": "Edit the name and the roles",
  "resetAria": "Reset the password of {{name}}",
  "resetTitle": "Reset the password: the old one stops working and open sessions close",
  "resetConfirm": "Reset the password of “{{name}}”? The old one stops working and open sessions close.",
  "resetFailed": "The password reset failed",
  "disableAria": "Disable {{name}}",
  "enableAria": "Enable {{name}}",
  "disableTitle": "Disable the account",
  "enableTitle": "Enable the account",
  "passwordReset": "The password of {{name}} was reset",
  "userCreated": "User {{name}} was created",
  "temporaryPasswordNote": "Hand the temporary password over in person. It is shown once and is not stored on the server in the clear.",
  "oldPasswordDead": "The old password no longer works and open sessions are closed.",
  "written": "Got it",
  "status": {
    "active": "Active",
    "disabled": "Disabled"
  },
  "column": {
    "name": "User",
    "email": "Email",
    "roles": "Roles",
    "lastLogin": "Last sign-in"
  },
  "form": {
    "name": "Name",
    "namePlaceholder": "Jane Smith",
    "emailHint": "Latin letters only in the mailbox name",
    "role": "Role",
    "roleRequired": "At least one role is required: without permissions an account looks functional but can do nothing."
  }
}
